<template>
    <!-- Meta Tags -->
    <Head title="Tu año en un minuto" />

    <div data-slide="slide" class="slide" >
        <div class="slide-items">

            <!-- History 1-->
            <div class="history w-screen bg-yellow" :class="{ active: activeIndex === 0 }">
                <div class="h-screen pt-16 flex flex-col justify-center items-center">
                    <div class="container flex flex-col justify-center items-center gap-4">
                        <img class="w-44 mx-auto" :src="`${$page.props.baseUrl}/images/2024.svg`" alt="2024" ref="h1Age" />
                        <h1 class="text-center text-5xl text-red" ref="h1Title1">
                            REVIVAMOS TU AÑO
                            <br>
                            EN UN MINUTO
                        </h1>
                        <div>
                            <p class="font-circular font-book text-gray text-xl text-center h-20" ref="h1Text">
                            </p>
                        </div>
                        <buttong class="font-circular bg-red rounded-full text-xl px-4 py-2" ref="h1Button">Veamos tus logros</buttong>
                    </div>
                    <div class="relative w-full h-48">
                        <img class="absolute top-0 -left-[8rem]" :src="`${$page.props.baseUrl}/images/history1/pink_hand.svg`" alt="Pink Hand" ref="h1HandPink"/>
                        <img class="absolute top-12 -right-[8rem]" :src="`${$page.props.baseUrl}/images/history1/white_hand.svg`" alt="White Hand" ref="h1HandWhite" />
                    </div>
                </div>
            </div>

        </div>
        <nav class="slide-nav" :class="controls ? 'h-full' : 'h-20'">
            <div class="slide-thumb flex flex-col">
                <div class="slide-thumb-content flex">
                    <span v-for="(item, index) in totalHistories" :key="index" @click="activeSlide(index)"
                          :class="{ active: activeIndex === index && play === true, pause: activeIndex === index && play === false }"
                    ></span>
                </div>
                <div class="flex justify-between items-center mt-2 px-4">
                    <div class="flex justify-start items-center gap-4">
                        <img class="w-10" :src="`${$page.props.baseUrl}/images/logo_holanda.png`" alt="Logo Holanda" />
                        <p class="text-xl">tu año en un minuto</p>
                    </div>
                    <div class="rounded-full" :class="play ? '' : 'bg-red'" @click="pause()">
                        <img class="w-8" :src="`${$page.props.baseUrl}/images/icon_pause.png`" alt="Icono Pausa" />
                    </div>
                </div>
            </div>
            <button v-if="controls" class="slide-prev" @click="prev"></button>
            <button v-if="controls" class="slide-next" @click="next"></button>
            <div v-if="shared" class="absolute left-0 bottom-0 w-full h-16" v-on:click="shareFb"></div>
        </nav>
    </div>


</template>

<script>
import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";

/* The following plugins are Club GSAP perks */
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";


gsap.registerPlugin(TextPlugin,ScrambleTextPlugin,SplitText);

export default {
    name: 'Home',
    props: {
        places: Object
    },
    components: {
    },
    setup() {
        return {
        };
    },
    data(){
        return {
            activeIndex: 0,
            interval: null,
            totalHistories: 0,
            timer: 15000,
            history1Executed: false,
            history2Executed: false,
            history3Executed: false,
            history4Executed: false,
            history5Executed: false,
            play: true,
            controls: false,
            question: false,
            shared: false
        };
    },
    mounted() {
        this.totalHistories = document.querySelectorAll('.history').length;
        this.showHistory1()
        this.autoSlide();
    },
    beforeUnmount() {
        clearInterval(this.interval);
    },
    methods: {
        showHistory1(){
            if(this.history1Executed === true){
                return false;
            }
            let tl = gsap.timeline()
            tl.from(this.$refs.h1HandPink, {
                left:"-100vw",
                duration: 1
            });
            tl.from(this.$refs.h1HandWhite, {
                right:"-100vw",
                duration: 1
            }, "<");
            tl.from(this.$refs.h1HandPink, {
                y:"+=40", yoyo:true, repeat:4
            });
            tl.from(this.$refs.h1HandWhite, {
                y:"-=40", yoyo:true, repeat:4
            }, "<");

            tl.from(this.$refs.h1Age, {
                scale: 0,
                ease: "bounce.out",
                duration: 1
            });
            tl.from(this.$refs.h1Title1, {
                opacity: 0,
                duration: 1
            });
            tl.from(this.$refs.h1Title2, {
                opacity: 0,
                duration: 1
            });
            tl.fromTo(this.$refs.h1Text, {
                text: ""
            },{
                duration: 2,
                text: "Fueron 365 días llenos de sabor en los que brindaste muchas sonrisas :)"
            });
            tl.from(this.$refs.h1Button, {
                opacity: 0,
                duration: 1
            });

            this.history1Executed = true;
        },
        showHistory2(){
            if(this.history2Executed === true){
                return false;
            }

            let tl2 = gsap.timeline()

            tl2.from(this.$refs.h2Title, {
                scale: 0,
                duration: 1
            });
            tl2.fromTo(this.$refs.h2Text, {
                text: ""
            },{
                duration: 3,
                text: "Si apilamos una sobre otra, formarían un gran edificio frío de <strong class='text-yellow'>132 pisos</strong>."
            });
            tl2.from(this.$refs.h2Building, {
                scale: 0,
                duration: 1
            });

            // Productos
            tl2.from(this.$refs.h2Product1, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product8, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product2, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product5, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product3, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product6, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product4, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product7, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");


            this.history2Executed = true;
        },
        showHistory3(){
            if(this.history3Executed === true){
                return false;
            }
            let tl3 = gsap.timeline()

            tl3.from(this.$refs.h3Title1, {
                scale: 0,
                duration: 1
            });
            tl3.from(this.$refs.h3Title2, {
                scale: 0,
                duration: 1
            });
            tl3.from(this.$refs.h3Bar1, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product1, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName1, {
                opacity: 0,
                duration: 1
            }, "<");

            tl3.from(this.$refs.h3Bar2, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product2, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName2, {
                opacity: 0,
                duration: 1
            }, "<");

            tl3.from(this.$refs.h3Bar3, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product3, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName3, {
                opacity: 0,
                duration: 1
            }, "<");

            this.history3Executed = true;
        },
        showHistory4(){
            if(this.history4Executed === true){
                return false;
            }
            let tl4 = gsap.timeline()


            tl4.from(this.$refs.h4Text1, {
                opacity: 0,
                duration: 1
            });
            tl4.from(this.$refs.h4Title, {
                opacity: 0,
                duration: 1
            });
            tl4.fromTo(this.$refs.h4Text2, {
                text: ""
            },{
                duration: 2,
                text: "Nada mal, podrías consentir a tu familia con"
            });
            tl4.from(this.$refs.h4Title2, {
                opacity: 0,
                duration: 1
            });
            tl4.fromTo(this.$refs.h4Products, {
                text: ""
            },{
                duration: 3,
                text: "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />"
            });
            this.history4Executed = true;
        },
        showHistory5(){
            if(this.history5Executed === true){
                return false;
            }
            let tl5 = gsap.timeline()

            tl5.from(this.$refs.h5Text1, {
                opacity: 0,
                duration: 1
            });
            tl5.from(this.$refs.h5Title, {
                opacity: 0,
                duration: 1
            });
            tl5.fromTo(this.$refs.h5Text2, {
                text: ""
            },{
                duration: 2,
                text: "Para lograr esta cifra, hubieras tenido que vender"
            });
            tl5.from(this.$refs.h5Data, {
                opacity: 0,
                duration: 1
            });
            tl5.from(this.$refs.h5Chips, {
                rotation: 10,
                yoyo:true,
                repeat: -1
            });
            tl5.from(this.$refs.h5Soda, {
                rotation: -10,
                yoyo:true,
                repeat: -1
            }, "<");

            this.history5Executed = true;
        },
        runAnimation() {
            switch (this.activeIndex) {
                case 0:
                    this.controls = false;
                    this.showHistory1();
                    break;
                case 1:
                    this.controls = true;
                    this.showHistory2();
                    this.shared = true
                    break;
                case 2:
                    this.controls = true;
                    this.showHistory3();
                    this.shared = true
                    break;
                case 3:
                    this.controls = true;
                    this.showHistory4();
                    this.shared = true
                    break;
                case 4:
                    this.controls = true;
                    this.showHistory5();
                    this.shared = true
                    break;
                case 5:
                    this.shared = false
                    if(this.question){
                        this.next()
                    }else{
                        this.controls = false;
                        clearInterval(this.interval);
                    }
                    break;
                case 6:
                    this.shared = false
                    this.controls = false;
                    clearInterval(this.interval);
                    break;
                default:
                    break;
            }
        },
        activeSlide(index) {
            this.activeIndex = index;
        },
        prev() {
            this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : 1;
            if (this.play){
                this.autoSlide()
            }
            this.runAnimation()
        },
        next() {
            this.activeIndex = this.activeIndex < this.totalHistories - 1 ? this.activeIndex + 1 : 0;
            if (this.play){
                this.autoSlide()
            }
            this.runAnimation()
        },
        autoSlide() {
            clearInterval(this.interval);
            this.interval = setInterval(this.next, this.timer);
        },
        pause() {
            this.play = !this.play
            if (this.play){
                this.autoSlide();
            }else{
                clearInterval(this.interval);
            }
        },
        reset(){
            this.activeIndex = 0
            this.showHistory1()
            this.autoSlide();
            this.controls = true;
        },
        sendAnswer() {
            this.question = true
            this.next()
        },
        shareFb(){
            FB.init({
                appId            : '1314533069676279',
                autoLogAppEvents : true,
                xfbml            : true,
                version          : 'v11.0'
            });

            FB.ui({
                method: 'share',
                quote: "Mira mi 2024 con Holanda",
                hashtag: "#Mi2024ConHolanda",
                href: "https://mi2024conholanda.com/abarrotes-la-perla-tapatia",
            }, function(response){});
        }
    }
};
</script>
<style>
.slide {
    @apply w-full grid;
}

.slide-items {
    @apply relative overflow-hidden;
    grid-area: 1/1;
}

.slide-nav {
    @apply grid;
    grid-area: 1/1;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr;
}

.slide-nav button {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    opacity: 1;
}

.slide-items > * {
    position: absolute;
    top: 0px;
    opacity: 0;
    pointer-events: none;
}

.slide-items > .active {
    position: relative;
    opacity: 1;
    pointer-events: initial;
}

.slide-thumb {
    @apply h-20 pt-2;
    display: flex;
    grid-column: 1 / 3;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.42) 100%);
}

.slide-thumb-content > span {
    flex: 1;
    display: block;
    height: 3px;
    background: rgba(255, 255, 255, 0.4);
    margin: 5px;
    border-radius: 3px;
    overflow: hidden;
}

.slide-thumb-content > span.active::after {
    content: '';
    display: block;
    height: inherit;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    transform: translateX(-100%);
    animation: thumb 15s forwards linear;
}

.slide-thumb-content > span.pause::after {
    content: '';
    display: block;
    height: inherit;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 3px;
    transform: translateX(-50%);
}

@keyframes thumb {
    to {
        transform: initial;
    }
}

</style>
